export const isBrowser = () => typeof window !== "undefined"

export const getUser = () =>
  isBrowser() && window.localStorage.getItem("gatsbyUser")
    ? JSON.parse(window.localStorage.getItem("gatsbyUser"))
    : {}

const setUser = user =>
  window.localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const handleLogin = ({ username, password },callback) => {
  fetch(process.env.GATSBY_API_URL+'/hello',{ 
    method: 'post', 
    headers: {
        //'Authorization': 'Bearer '+ window.user.jeton,
        'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ 'id' : username , 'pass':password })
  })
    .then((reponse) => {
      if(reponse.status !== 200){
        throw new Error('auth failed');
      }
      return reponse;
    })
    .then(res => res.json())
    .then(
      (result) => {
        //console.log(result);
        let denomination="";
        if(result.prenom !=null) denomination+=`${result.prenom}`;
        if(result.nom !=null) denomination+=` ${result.nom}`;
        setUser({
          identifiant: result.identifiant,
          role: result.role,
          denomination:denomination,
          jeton: result.jeton,
          exipres: Date.now() + 2 * 3600 * 1000
        })
        return callback(true)
      })
    .catch(error => {console.log("auth failled"); console.log(error);});
}

export const isLoggedIn = () => {
  const user = getUser()
  if(!user.identifiant) return false;
  if(user.expires < Date.now()) {setUser({}); return false;}
  return true;
}

export const logout = callback => {
  setUser({})
  callback()
}